import MuiLabLoadingButton from '@mui/lab/LoadingButton'
import type { LoadingButtonProps as MuiLabLoadingButtonProps } from '@mui/lab/LoadingButton'
import { Tooltip, type TooltipProps } from '@mui/material'

// import type { LoadingButtonProps as MuiLabLoadingButtonProps } from '@mui/lab'
// import { Tooltip, type TooltipProps } from '@mui/material'

export type LoadingButtonProps = MuiLabLoadingButtonProps & { tooltip?: string; tooltipProps?: TooltipProps }

const a: MuiLabLoadingButtonProps['sx'] = {}

/**
 * @warning
 * Uses `@mui/lab` ALPHA level components
 *
 * @caveat
 * May need to wrap `Tooltip` in a `<div>` or `<span>`
 * * https://github.com/mui-org/material-ui/issues/15663 */
export const LoadingButton = ({ tooltip, tooltipProps, children, ...rest }: LoadingButtonProps) => {
    return tooltip || tooltipProps ? (
        <Tooltip title={tooltip} {...tooltipProps}>
            <span>
                <MuiLabLoadingButton {...rest}>
                    <span>{children}</span>
                </MuiLabLoadingButton>
            </span>
        </Tooltip>
    ) : (
        <MuiLabLoadingButton {...rest}>
            <span>{children}</span>
        </MuiLabLoadingButton>
    )
}
